import dayjs from 'dayjs';

export function getFormattedTimestamp(timestamp: string | Date | number, formatString: string): string {
	const timestampDate = dayjs(timestamp);
	return timestampDate.format(formatString);
}
